import React, { useEffect } from "react";
import "./Terms.css";

export default function Terms(): JSX.Element {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main className="terms-page">
      <section className="terms-hero">
        <div className="terms-hero-inner">
          <h1>Terms and Conditions</h1>
          <p>
            The key terms for Jortel services are provided below. For full
            service-specific terms or a signed copy, contact our team.
          </p>
        </div>
      </section>

      <section className="terms-body">
        <div className="terms-card">
          <h2>Full Terms (PDF)</h2>
          <p className="terms-note">
            The full Jortel Terms and Conditions are provided below. You can
            view them here or download a copy.
          </p>
          <div className="terms-doc">
            <iframe
              className="terms-iframe"
              src="/docs/JORTEL_Full_Terms_and_Conditions.pdf"
              title="Jortel Full Terms and Conditions"
            />
          </div>
          <a
            className="terms-download"
            href="/docs/JORTEL_Full_Terms_and_Conditions.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Terms and Conditions (PDF)
          </a>
        </div>
      </section>
    </main>
  );
}
